<template>
  <dv-active-ring-chart v-if="config.data" :config="config" style="width:100%;height:100%" />
</template>

<script>
import { getStudentBySignApi } from '@/api/school'
export default {
  name: 'StudentCountForSignCourseCount',
  data () {
    return {
      config: {},
      signData: null
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    subSchoolId () {
      return this.$store.getters.subSchoolId
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getStudentBySignApi({ schoolId: this.schoolId }).then(res => {
        this.signData = res.result;
        this.drawLine()
        setTimeout(this.getData, 1200000)
      })
    },
    drawLine () {
      let config = {
        radius: '80%',
        activeRadius: '85%',
        showOriginValue: true,
        data: []
      }

      if (this.signData.radiusAxis.length) {
        for (let i = 0; i < this.signData.radiusAxis.length; i++) {
          config.data.push(
            {
              name: this.signData.radiusAxis[i],
              value: Number(this.signData.series[0].data[i])
            }
          )
        }
      }

      this.config = config
    }
  }
}
</script>

<style lang="less">

.chart {
    width: 100%;
    height: 180px !important;
}
</style>
